<div class="border border-black p-3 mb-4">
	<form class="row no-gutters" #formCarrello="ngForm">
		<p class="ont-16 mb-3">Shop by Product Code</p>
		<input
			type="text"
			class="form-control mb-2 rounded-0 form-bertazzoni white"
			placeholder="PRODUCT NUMBER"
			[(ngModel)]="jsonInAddTocart.codiceCommerciale"
			name="codiceCommerciale"
			required />
		<div class="number-input mb-3">
			<div (click)="stepQuantitaGenerico('-')" class="selettore-spin"></div>
			<input
				class="quantity form-bertazzoni"
				min="0"
				max="100"
				name="quantity"
				value="1"
				type="number"
				[(ngModel)]="jsonInAddTocart.quantita"
				required />
			<div (click)="stepQuantitaGenerico('+')" class="selettore-spin plus"></div>
		</div>
	</form>
	<div class="row">
		<div class="col-6">
			<button
				type="button"
				class="btn btn-bertazzoni black btn-block rounded-0 py-2"
				(click)="openPreview(content)"
				[disabled]="formCarrello.invalid">
				PREVIEW
			</button>
		</div>
		<div class="col-6">
			<button
				type="button"
				class="btn btn-bertazzoni black btn-block rounded-0 py-2"
				(click)="shopByCode(scegliProdottoModal)"
				[disabled]="formCarrello.invalid || jsonInAddTocart.quantita == 0">
				ADD TO CART
			</button>
		</div>
	</div>
</div>

<ng-template #content let-modal>
	<div class="modal-header" *ngIf="prodottoPreview">
		<h5 class="modal-title" id="">{{prodottoPreview.selected.codiceCommerciale}}</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body" *ngIf="prodottoPreview">
		<div class="border p-3 mb-4">
			<div class="row align-items-center">
				<div class="col-lg-3 col-5">
					<img *ngIf="prodottoPreview.selected.immagini.length == 0" src="assets/img/no-img.png" />
					<img
						*ngIf="prodottoPreview.selected.immagini.length > 0"
						[src]="prodottoPreview.selected.immagini[prodottoPreview.selected.imgIndex]?.path | img" />
					<div class="text-center" *ngIf="prodottoPreview.selected.immagini.length > 1">
						<img
							src="assets/img/back.svg"
							class="tracking carousel-icon m-2"
							onmouseover="this.src='assets/img/back-w.svg'"
							onmouseout="this.src='assets/img/back.svg'"
							(click)="prodottoPreview.selected.imgIndex = prodottoPreview.selected.imgIndex-1"
							*ngIf="prodottoPreview.selected.imgIndex>0" />
						<img
							src="assets/img/next.svg"
							class="tracking carousel-icon m-2"
							onmouseover="this.src='assets/img/next-w.svg'"
							onmouseout="this.src='assets/img/next.svg'"
							(click)="prodottoPreview.selected.imgIndex = prodottoPreview.selected.imgIndex+1"
							*ngIf="prodottoPreview.selected.imgIndex+1 < prodottoPreview.selected.immagini.length" />
					</div>
				</div>
				<div class="col-lg-9 col-7">
					<div class="d-lg-flex justify-content-between">
						<div class="col-9">
							<p class="font-18 font-semibold">{{getDescrizione(prodottoPreview)?.valore }}</p>
							<p class="font-16 mb-0" *ngIf="!prodottoPreview.isNeutral">
								{{prodottoPreview.lineaEstetica | translate | titlecase}} Series
							</p>
							<p class="text-secondary">{{prodottoPreview.selected.codiceCommerciale}}</p>
						</div>
						<div class="col-3 text-right">
							<p class="font-semibold font-18 mb-0">{{ '' | valuta }} {{prodottoPreview.selected.listini[0].prezzoNetto | number}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #scegliProdottoModal let-modal>
	<div class="modal-header">
		<h6 class="modal-title" id="">Choose gas type - {{prodottiPerTipoGas[0].codiceCommerciale}}</h6>
		<button type="button" class="close" aria-label="Close" (click)="modal.close()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div *ngFor="let prodotto of prodottiPerTipoGas" class="mb-2">
			<a (click)="scegliTipoGas(prodotto, modal)">
				<u>{{prodotto.tipoGas}}</u>
			</a>
		</div>
	</div>
</ng-template>
